import { Col, Row } from "reactstrap";
import SteamLogo from "../../../assets/RealEnglishImages/SteamLogo.png"
import Drama from "../../../assets/RealEnglishImages/dramaLogo.png"

const NewWayToLearnEnglish = () => {
  return (
    <>
    <Row className="justify-content-center">
        <Col lg={8}>
          <div className="text-center mt-lg-5 pt-3">
            <h1 className="mb-3 ff-secondary fw-semibold lh-base">
              A New Way to Learn English
            </h1>
            <p className="lead lh-base">
              We are the exclusive partner of two cutting-edge learning
              programs:
            </p>
          </div>
        </Col>
      </Row>
      <Row className="g-3 pt-3 align-items-center justify-content-center">
        <Col lg={6}>
          <div className="d-flex align-items-start align-items-md-center p-3">
            <div className="flex-shrink-0 me-3">
             
                <img
                  src={SteamLogo}
                  alt="STEAM Logo"
                  className="img-fluid "
                  style={{ height: "170px" }}
                />

            </div>
            <div className="flex-grow-1">
              <h5 className="fs-18">The STEAM Network:</h5>
              <p className="my-3 lead lh-base">
                Junior students explore Science, Technology, Engineering,
                Arts, and Mathematics through exciting projects and
                experiments. This hands-on approach not only makes learning
                fun but also helps them develop English skills in a
                meaningful, real-world context.
              </p>
            </div>
          </div>
        </Col>

        <Col lg={6}>
          <div className="d-flex align-items-start align-items-md-center p-3">
            <div className="flex-shrink-0 me-3">
                <img
                  src={Drama}
                  alt="Drama Logo"
                  className="img-fluid"
                  style={{ height: "170px" }}
                />

            </div>
            <div className="flex-grow-1">
              <h5 className="fs-18">The English Drama Method:</h5>
              <p className="my-3 lead lh-base">
                Available for all levels, this unique method transforms
                English learning into an adventure with acting games,
                role-playing, and storytelling. Students gain fluency,
                confidence, and creativity—all while having fun!
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default NewWayToLearnEnglish;
